import React from 'react';
import CTA from '../CTA';
import * as styles from './PageBlocks.module.styl';

export default function CTABlock(props) {
  return (
    <div
      className={[styles.ContentBlock]}
      style={{ textAlign: 'center', padding: '3rem 2rem', maxWidth: '60rem' }}
    >
      <h2 className="mx-auto max-w-3xl">{props.title}</h2>
      <p className="mx-auto max-w-3xl lg:px-10">{props.byline}</p>
      <CTA btnText={props.button_label} />
    </div>
  );
}
